import { createBuilderModule } from '../../register-builder/builder-module';
import { HubSpotForm } from './HubSpotForm';

export default createBuilderModule(HubSpotForm, {
  name: 'HubSpotForm',
  image: 'https://cdn.zappy.app/65aca327f8d8f58911a8564e9ab0500d.png',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Request a demo',
      required: true,
    },
    {
      name: 'description',
      type: 'richText',
      defaultValue:
        '<p>We get it: Buying essential software for your business is hard. ' +
        'But we want to make it easier.</p>',
    },
    {
      name: 'hubspotPortalId',
      type: 'string',
      defaultValue: '7462085',
      required: true,
    },
    {
      name: 'hubspotFormId',
      type: 'string',
      required: true,
    },
    {
      name: 'prefilledFields',
      helperText:
        'Use to have any fields prefilled when the form loads. This can also be used for hidden fields. https://legacydocs.hubspot.com/docs/methods/forms/advanced_form_options',
      type: 'list',
      subFields: [
        {
          friendlyName: 'Field name / contact property',
          helperText:
            'The contact property in Hubspot, which is also the "name" property of the HTML input. https://cdn.zappy.app/203ef02c90c194e3c4c1ae36d7636a00.png',
          name: 'name',
          required: true,
          type: 'string',
        },
        {
          friendlyName: 'Field Value',
          helperText:
            'The value that you would like to pre-populate in the field.',
          name: 'value',
          required: true,
          type: 'string',
        },
      ],
    },
  ],
});
